module.exports = __webpack_public_path__ + "img/2.5b4dd317.webp";